import {useDispatch} from "react-redux";
import {pushRouteParams} from "state/actions/router";
import {useCallback} from "react";

export function useRouteParams() {
    const dispatch = useDispatch();
    return useCallback(params => {
        dispatch(pushRouteParams(params));
    }, [dispatch]);
}